
import Vue from "vue";
import AppFileUpload from "@/components/FileUpload.vue";
import { Script } from "@/models/script";

export default Vue.extend({
	data(){
		return {
			file: null as null | File
		};
	},
	methods: {
		close(){
			this.$emit("close");
		},
		onModalInput(value:boolean){
			if (value) {
				this.close();
			}
		},
		onFile(file:File){
			let validTypes = [
				"text/plain",
				"text/json",
				"application/json"
			];
			if (validTypes.indexOf(file.type) == -1) {
				this.$wf.notify(`Bestands type ${file.type} is niet valide`, "danger", 3000, "exclamation-triangle");
				return;
			}
			this.file = file;
		},
		async confirm(){
			if (!this.file) return;
			let content = await this.file.text();
			let script = new Script(JSON.parse(content));
			this.$emit("input", script);
			this.close();
		}
	},
	components: {
		AppFileUpload
	}
});

